import { HttpHeaders } from '@angular/common/http';
import { from } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { APIErrorHandler } from './api-error-handler.service';
import { AppConfigService } from '@app/app-config.service';
import { MsalService } from '@azure/msal-angular';
var APIInterceptor = /** @class */ (function () {
    function APIInterceptor(_appConfig, errorHandler, msalService) {
        this._appConfig = _appConfig;
        this.errorHandler = errorHandler;
        this.msalService = msalService;
        this._config = this._appConfig.getConfig();
    }
    APIInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        var requestUrl = request.url;
        var apiScope = this._config.msalConfig.geobrain_scope;
        if (requestUrl.includes(this._config.datascience_api_baseurl) || requestUrl.includes(this._config.geoBertAPIUrl)) {
            return from(this.msalService.acquireTokenSilent({
                scopes: [apiScope]
            })).pipe(switchMap(function (token) {
                if (!_this._config.datascience_api_token) {
                    request = request.clone({
                        headers: new HttpHeaders({
                            'Cache-Control': 'no-cache',
                            'Pragma': 'no-cache'
                        }),
                        withCredentials: true
                    });
                }
                else {
                    request = request.clone({
                        headers: new HttpHeaders({
                            'Cache-Control': 'no-cache',
                            'Pragma': 'no-cache'
                        }),
                        setHeaders: {
                            'Authorization': 'Bearer ' + token.accessToken
                        }
                    });
                }
                return next.handle(request);
            }), catchError(function (err) {
                // don't let a failed silent token refresh drop the request with no response at all
                _this.errorHandler.handleError(err);
                return next.handle(request);
            }));
        }
        else if (requestUrl.includes(this._config.ihs_api_baseurl)) {
            // IHS SDE API is called directly (bypassing APIM), so attach the bearer token here.
            return from(this.msalService.acquireTokenSilent({
                scopes: [apiScope]
            })).pipe(switchMap(function (token) {
                request = request.clone({
                    headers: new HttpHeaders({
                        'Cache-Control': 'no-cache',
                        'Pragma': 'no-cache'
                    }),
                    setHeaders: {
                        'Authorization': 'Bearer ' + token.accessToken
                    }
                });
                return next.handle(request);
            }), catchError(function (err) {
                _this.errorHandler.handleError(err);
                return next.handle(request);
            }));
        }
        else {
            return next.handle(request);
        }
    };
    return APIInterceptor;
}());
export { APIInterceptor };
